import React, { useCallback, useRef, useState } from 'react'
import classNames from 'classnames'

import { useOnClickOutside } from '@/hooks'
import { IOption } from '@/types'

import { IPopupProps } from './types'

export const Popup = <T,>({
  name,
  label,
  value,
  options,
  onChange,
  required,
  className,
  placeholder,
  optionClassName,
}: IPopupProps<T>) => {
  const [isOpen, setOpen] = useState(false)
  const divRef = useRef<HTMLDivElement>(null)

  const onToggle = useCallback(() => {
    setOpen(prev => !prev)
  }, [])

  useOnClickOutside(divRef, isOpen, onToggle)

  const _onSelect = useCallback(
    (option: IOption<T>) => () => {
      onChange?.(option)
      onToggle()
    },
    [onToggle, onChange],
  )

  return (
    <div ref={divRef} className={classNames('', className)}>
      {!!label && (
        <label htmlFor={name}>
          {label} {required && <sup>*</sup>}
        </label>
      )}
      <div id={name} className="popup_input" onClick={onToggle}>
        {options?.find(_v => _v.value === value)?.label ?? placeholder}
      </div>
      <div
        className={classNames('popup', {
          open: isOpen,
        })}
      >
        <div className="popup_list">
          {options.map((option, idx) => (
            <div
              key={idx}
              onClick={_onSelect(option)}
              className={classNames('popup_list_item', optionClassName)}
            >
              {option.label}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
